export const NameHelper = (name: string ) => {
    const nameLastname = name.trim().split(" ");
    
    return (nameLastname.length > 1) ? `${name[0]}${nameLastname[nameLastname.length - 1][0]}` : `${name[0]}${name[1]}`; 
}

export default NameHelper;